import React from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};

var TriangleOutline = function TriangleOutline(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return React.createElement('svg', {
    height: size,
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('path', {
    id: 'Vector',
    d: 'M9.99992 7.5V10.8333M9.99992 14.175L10.0083 14.1657M17.5656 17.5H2.14439C1.73474 17.5 1.56173 17.2715 1.88627 16.7305L9.53082 2.94808C9.92718 2.35586 10.1709 2.34541 10.6334 2.9482L18.3019 16.7305C18.518 17.2715 18.3173 17.5 17.5656 17.5Z',
    stroke: color,
    strokeWidth: '1.25',
    strokeLinecap: 'round'
  }));
};

TriangleOutline.propTypes = propTypes;
export default TriangleOutline;